export default __webpack_public_path__ + "static/media/kronkgame.cf95f408.jpg";